import React, { useEffect } from 'react';
import YoutubeContact from '../components/contact/YoutubeContact';
import FAQPage from '../components/contact/FAQPage';
import SEO from '../components/SEO';

const YoutubeContactPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <SEO
                title="Connect with Skill Ascent | Community & Admissions"
                description="Connect with Skill Ascent through our official YouTube community and course inquiry portal."
                canonicalPath="/youtube-contact"
                breadcrumbs={[
                    { name: "Home", url: "/" },
                    { name: "YouTube Community", url: "/youtube-contact" }
                ]}
            />

            <YoutubeContact />
            <FAQPage />
        </>
    );
};

export default YoutubeContactPage;
